exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mrf-section{margin:1em\n}\n.mrf-section table{width:100%;text-align:left;padding-left:10px;padding-bottom:20px\n}\n.mrf-section table th,.mrf-section table td{width:180px;max-width:360px;overflow:hidden;vertical-align:text-top\n}\n.mrf-section table th+th,.mrf-section table td+td{width:auto\n}", ""]);

// exports
